
import makerjs from "makerjs";
function A33(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    W = Param[0].param,H = Param[1].param, H1 = Param[2].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       h = H * 1 * myZoom,
       h1 = H1 * 1 * myZoom,
       w = W * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       x0 = 0, x1 = 0, x2 = w/2, x3 = w,x4=w, y0 = 0, y1 = h-h1, y2 = h,y3=h-h1, y4 = 0,glassH = h, glassW = w;

   if (h !== 0) {
       var TxtH = H;
   } if (h1 !== 0) {
  var TxtH1 = H1;
}
   if (w !== 0) {
       var TxtW = W;
   }



   var drawAbnormalShapeA33 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]), 
        "ArcLine": new makerjs.paths.Arc([x1,y1], [x2,y2],[x3,y3]),
        "RightLine": new makerjs.paths.Line([x3, y3], [x4, y4]),
        "BottomLine": new makerjs.paths.Line([x4, y4], [x0, y0]),
       }
   };
   var drawAbnormalShapeA33MarkH1 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x3+markShift, y3], [x3+markShift, y2]),
        "LeftShortUpline": new makerjs.paths.Line([x3, y3], [x3 + 3 * markShift, y3]),
        "LeftShortDnline": new makerjs.paths.Line([x3-markShift, y2], [x3 + 3 * markShift, y2]),
       }
   };
   var drawAbnormalShapeA33MarkH = {
       paths: {
        "RightLine": new makerjs.paths.Line([x0- markShift, y0], [x0- markShift, y2]),
        "RightShortUpline": new makerjs.paths.Line([x0, y2], [x0- 2 * markShift, y2]),
        "RightShortDnline": new makerjs.paths.Line([x0, y0], [x0- 2 * markShift, y0]),
       }
   };
   var drawAbnormalShapeA33MarkW = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0 - markShift], [x4, y4 - markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x4, y4], [x4, y4 - 2 * markShift]),
       }
  //  };
  
   };
   makerjs.model.addCaption(drawAbnormalShapeA33MarkW, TxtW, [x0, y0 - 2 * markShift], [x4, y4 - 2 * markShift]);//长度文字  
   makerjs.model.addCaption(drawAbnormalShapeA33MarkH, TxtH, [x0 - 2 * markShift, y0], [x0 - 2 * markShift, y2]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeA33MarkH1, TxtH1, [x3 +  2*markShift, y3], [x3 + 2*markShift, y2]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeA33: drawAbnormalShapeA33,
      }
    };
    markers={
      models: {
        drawAbnormalShapeA33: drawAbnormalShapeA33,
        drawAbnormalShapeA33MarkH1: drawAbnormalShapeA33MarkH1,
        drawAbnormalShapeA33MarkH:drawAbnormalShapeA33MarkH,
        drawAbnormalShapeA33MarkW:drawAbnormalShapeA33MarkW
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default A33;